if (window.gl_debug) window.addEventListener('DOMContentLoaded', ()=>{

    [
        {
            ver:"ECMAScript 2016",
            features:[
                {eval:'1**1;'},
                {eval:'let a=1;a**=1;'},
                {eval:'[].includes(0);'},
            ]
        },
        {
            ver:"ECMAScript 2017",
            features:[
                {eval:'"".padStart(1,"x");'},
                {eval:'"".padEnd(1,"x");'},
                {eval:'Object.entries({});'},
                {eval:'Object.values({});'},
                {eval:'async ()=>{};'},
            ]
        },
        {
            ver:"ECMAScript 2018",
            features:[
                {eval:'async ()=>{ for await (const x of null) {} };'},
                {eval:'(new Promise(()=>0)).finally();'},
                {eval:'let {x,y,...z}={x:1, y:2, a:3, b:4};'},
                // regexp property escape //
                {eval:'if (! /\\p{Emoji_Presentation}/gu.test("👌") ) throw "regexp property escape";'},
                // regexp Lookbehind Assertions //
                {eval:'if ("aabb".match(/aa(?=bb)/)[0] !== "aa") throw "regexp Lookbehind Assertions";'},
                // regexp named capture groups //
                {eval:'var {groups:{test}}=/a(?<test>.*)/.exec("ab"); if (test !== "b") throw "regexp named capture groups";'},
                // regexp dotAll //
                {eval:'if (! /./s.dotAll) throw "regexp dotAll";'},
                // worker //
                {eval:'Worker;'},
                // shared memory // -- není dostupné skrz nějakou csp crossorigin či co //
                // {eval:'SharedArrayBuffer;'},
            ]
        },
        {
            ver:"ECMAScript 2019",
            features:[
                {eval:'"".trimStart();'},
                {eval:'"".trimEnd();'},
                {eval:'Object.fromEntries([]);'},
                {eval:'try {} catch {};'},
                {eval:'[].flat();'},
                {eval:'[].flatMap(()=>0);'},
                // test stabilního řazení //
                {eval:'let arr=[{x:0, y:0},{x:1, y:0},{x:2, y:0},{x:3, y:0},{x:4, y:1},{x:5, y:1},{x:6, y:1},{x:7, y:1},'
                +'{x:8, y:2},{x:9, y:2},{x:10, y:2},{x:11, y:2},{x:12, y:3},{x:13, y:3},{x:14, y:3},{x:15, y:3}];'
                +'if (arr.sort((a,b)=>a.y<b.y?-1:a.y==b.y?0:1).some((a,i,arr)=>i&&a.x<arr[i-1].x)) throw "Array.sort() nepoužívá stabilní algoritmus.";'},
                // test JSON.stringify UTF8 //
                {eval:'if (JSON.stringify("\\u26D4") !== \'"⛔"\') throw "JSON UTF-8 code points (U+D800 to U+DFFF) broken"'},
                // test UTF8 line a paragraph separator
                {eval:'"\u2028 \u2029"'},
                {eval:'if ((()=>0).toString() !== "()=>0") throw "Fonction.toString() not revised."'},
            ]
        },
        {
            ver:"ECMAScript 2020",
            features:[
                {eval:'let a=9999999999999999n; let b=BigInt(1234567890123456789012345);'}, // bigint
                {eval:'"".matchAll(/./g);'},
                {eval:'let a=null??null; a??=null;'},
                {eval:'null?.property;'},
                {eval:'let a=1; a&&=1; a||=1;'},
            ]
        },
        {
            ver:"ECMAScript 2021",
            features:[
                {eval:'async ()=>await Promise.any([()=>0]);'},
                {eval:'"".replaceAll(/./g, "");'},
                {eval:'1_0;'},
            ]
        },
        {
            ver:"ECMAScript 2022",
            features:[
                {eval:'let x=class{y=0;#z=0;static x=0;};'},
                {eval:'let x=class{static{}};'},
                {eval:'let x=class{#y;f(){return y in this};};'},
                // regexp indicies //
                {eval:'/./d.exec("a").indices[0][0];'},
                // top level await // lze jen uvnitř script type="module"
                {module:'await(()=>0)()'},
                {eval:'[].at(0);'},
                {eval:'Object.hasOwn(0,{});'},
                {eval:'new Error("x", {a:"b"});'},
            ]
        },
        {
            ver:"ECMAScript 2023",
            features:[
                {eval:'[].findLast(()=>0)'},
                {eval:'[].findLastIndex(()=>0)'},
                {eval:'[].toReversed()'},
                {eval:'[].toSorted()'},
                {eval:'[].toSpliced()'},
                {eval:'[0].with(-1,1)'},
            ]
        },
    ].forEach((t)=>{
        window.es6_test_result=true;
        t.features.forEach((f)=>{
            if (f.eval) {
                try {
                    eval(f.eval)
                } catch (e) {
                    console.info(t.ver + ' nepodporováno: ' + f.eval, e);
                    es6_test_result = false;
                }
            }
            if (f.module) {
                let s=document.createElement("script");
                s.setAttribute("type", "module");
                s.innerText='try{'+f.module+'}catch(e){console.info("'+t.ver+' nepodporováno '+(f.module.replace(/"/g, '\\"'))+'", e);window.es6_test_result=false;}';
                document.body.appendChild(s);
                document.body.removeChild(s);
            }
        })
        if (es6_test_result) console.info(t.ver+" podporováno.");
        delete window.es6_test_result;

    });


});